import { Box } from "@mui/material";
import React from "react";

function normalizeVersion(value) {
  const raw = String(value || "V1").trim().toUpperCase();
  if (raw === "1" || raw === "V1") return "V1";
  if (raw === "2" || raw === "V2") return "V2";
  return raw.startsWith("V") ? raw : `V${raw}`;
}

/**
 * Shared V1/V2 pill used in API logs tables and the log detail header.
 */
const VersionBadge = ({ version }) => {
  const value = normalizeVersion(version);
  const isV2 = value === "V2";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 42,
        px: 1.25,
        py: 0.35,
        borderRadius: "999px",
        bgcolor: isV2 ? "#1E53D7" : "#22D3EE",
        color: "#fff",
        fontSize: 12,
        fontWeight: 700,
      }}
    >
      {value}
    </Box>
  );
};

export { normalizeVersion };
export default VersionBadge;
